import React, { useState } from 'react'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'
import LeftArrow from '../../../assets/left.png'
import RightArrow from '../../../assets/right.png'
import { isEmpty } from 'lodash'
import { withTheme } from 'theming'
import SliderWrapper from './_SlickSlider'
import EditMenu from '../editMenu'
import CustomImage from '../../customImage/customImage'
import AddSection from '../addSection'
import PassimPlayer from '../rosemary/passimPlayer'
import useTemplateHook from '../templateHook'

const EventCoverBanner = ({
  componentData,
  modifyData,
  setModalState,
  isEdit,
  onSwap,
  onDelete,
  onCopy,
  theme,
  onAdd,
}) => {
  const { data, id } = componentData
  const [hoverState, setHoverState] = useState('')
  const { getTemplateImage, customNavigate } = useTemplateHook()

  function SampleNextArrow(props) {
    const { className, style, onClick } = props
    return (
      <div
        className={className}
        style={{
          ...style,
          width: '38px',
          height: '38px',
          position: 'absolute',
          top: '50%',
          right: '0px',
          transform: 'translateY(-50%)',
          zIndex: '10',
          content: `url(${RightArrow})`,
        }}
        onClick={onClick}
      >
        <img src={RightArrow} alt="Next" style={{ width: '100%', height: '100%' }} />
      </div>
    )
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props
    return (
      <div
        className={className}
        style={{
          ...style,
          width: '38px',
          height: '38px',
          position: 'absolute',
          top: '50%',
          left: '0px',
          transform: 'translateY(-50%)',
          zIndex: '10',
          content: `url(${LeftArrow})`,
        }}
        onClick={onClick}
      >
        <img src={LeftArrow} alt="Previous" style={{ width: '100%', height: '100%' }} />
      </div>
    )
  }

  const handleRedirect = (linkObj) => {
    customNavigate('INDIRECT', linkObj, isEdit)
  }

  const settings = {
    dots: true,
    autoplay: data?.auto_play,
    autoplaySpeed: 2500,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    centerPadding: '0px',
    pauseOnHover: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,

    appendDots: (dots) => {
      return (
        <div
          style={{
            backgroundColor: 'transparent',
            borderRadius: '0px',
            padding: '0px',
            position: 'absolute',
            bottom: '-35px',
            width: '100%',
            left: '0',
            textAlign: 'center',
          }}
          className=""
        >
          <ul>
            {dots.map((info, idx) => (
              <li key={idx} className={`${info.props.className}`}>
                <div
                  style={{
                    backgroundColor: `${
                      info.props.className === 'slick-active' ? 'white' : 'grey'
                    }`,
                    opacity: `${info.props.className === 'slick-active' ? '1' : '0.3'}`,
                  }}
                  className="ft-slick__dots--custom"
                  onClick={info.props.children.props.onClick}
                >
                  <div className="" />
                </div>
              </li>
            ))}
          </ul>
        </div>
      )
    },
    customPaging: (i) => (
      <div className="ft-slick__dots--custom">
        <div className="" />
      </div>
    ),
  }

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }

  const config = {
    LEFT: 'justify-start items-center text-left',
    CENTER: 'justify-center items-center text-center',
    RIGHT: 'justify-end items-center text-right',
  }

  return (
    <div
      className={`w-full py-6  relative  ${isEdit && hoverState && 'component-hover-class'} `}
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
      style={{ background: getStyleValue('component_background', 'color', '') }}
    >
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onDelete={() => onDelete(id)}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
          onEdit={() => handleModal()}
          onCopy={() => onCopy(id)}
        />
      )}
      <div style={{ maxWidth: '1269px', margin: '0 auto' }}>
        <SliderWrapper>
          <Slider {...settings}>
            {data?.slide_data?.map((slide) => (
              <div key={slide.id}>
                <div className="rounded mb-1 relative" onClick={() => handleRedirect(slide.link)}>
                  {isEdit || !slide?.player?.type ? (
                    <CustomImage
                      imageUrl={getTemplateImage(slide.image_s3key)}
                      imgAlt={slide.heading}
                      imgClass="w-full h-full object-contain"
                      loaderClass="w-full"
                      loaderStyle={{ aspectRatio: '1269/376' }}
                    />
                  ) : (
                    <div className="absolute -z-10 w-full h-full">
                      <PassimPlayer
                        data={slide?.player}
                        poster={getTemplateImage(slide?.image_s3key)}
                        controlBar={false}
                        isBanner={true}
                        iconPositionClass={'decomposed-banner-player-icon'}
                        onClickRedirect={() => handleRedirect(slide.link)}
                      />
                    </div>
                  )}

                  <div className={`z-10 absolute inset-0 flex ${config[slide.position]} px-4`}>
                    <div className={`w-full lg:w-[30%] flex mt-5 ml-5 mr-5 flex-col  z-10`}>
                      <p
                        style={{
                          color: getStyleValue('heading', 'color', '#fff'),
                          fontFamily: getStyleValue('heading', 'font', ''),
                        }}
                        className={`text-sm md:text-lg mb-0 lg:text-xl xl:text-2xl ${getStyleValue(
                          'heading',
                          'font_format',
                          '',
                        )} line-clamp-3`}
                      >
                        {slide.heading}
                      </p>

                      <p
                        style={{
                          color: getStyleValue('sub_heading', 'color', '#fff'),
                          fontFamily: getStyleValue('sub_heading', 'font', ''),
                        }}
                        className={`font-normal text-xs hidden lg:block ${getStyleValue(
                          'sub_heading',
                          'font_format',
                          '',
                        )} text-base mb-0 mt-2`}
                      >
                        {slide.sub_heading}
                      </p>
                      {slide?.cta_button?.enabled && (
                        <div className={`w-full flex ${config[slide.position]}`}>
                          <button
                            style={{
                              backgroundImage: `linear-gradient(to ${getStyleValue(
                                'button',
                                'gradient',
                                'left',
                              )}, ${getStyleValue(
                                'button',
                                'primary_color',
                                theme.c2,
                              )}, ${getStyleValue('button', 'secondary_color', theme.c2)})`,
                              color: getStyleValue('button', 'text_color', '#fff'),
                              borderRadius: '6px',
                            }}
                            className={`border-0 py-1 px-3 text-xs md:text-base mt-3`}
                          >
                            {slide.cta_button.text}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </SliderWrapper>
      </div>
      {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
    </div>
  )
}

export default withTheme(EventCoverBanner)
